import React, { useContext, createContext } from 'react';
import PropTypes from 'prop-types';

import useProvideDialog from './_useProvideDialog';

const dialogContext = createContext();

export const ProvideDialog = ({ children }) => {
  const dialog = useProvideDialog();
  return (
    <dialogContext.Provider value={dialog}>{children}</dialogContext.Provider>
  );
};

ProvideDialog.propTypes = {
  children: PropTypes.node,
};

export const useDialog = () => {
  return useContext(dialogContext);
};
